export const OPTIONS_FILTERS_ENUM_TYPES = {
  LAST_DAY: 'LAST_DAY',
  LAST_2_DAYS: 'LAST_2_DAYS',
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_2_WEEKS: 'LAST_2_WEEKS',
  LAST_1_MONTH: 'LAST_1_MONTH',
  LAST_2_MONTH: 'LAST_2_MONTH',
  LAST_6_MONTH: 'LAST_6_MONTH',
  LAST_1_YEAR: 'LAST_1_YEAR',
  LAST_2_YEAR: 'LAST_2_YEAR',
}

export const selectOptions = [
  { label: 'Last day', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_DAY },
  { label: 'Last 2 days', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_2_DAYS },
  { label: 'Last 7 days', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_7_DAYS },
  { label: 'Last 2 weeks', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_2_WEEKS },
  { label: 'Last 1 month', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_1_MONTH },
  { label: 'Last 2 month', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_2_MONTH },
  { label: 'Last 6 month', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_6_MONTH },
  { label: 'Last 1 year', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_1_YEAR },
  { label: 'Last 2 year', value: OPTIONS_FILTERS_ENUM_TYPES.LAST_2_YEAR },
]



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/Charts/options.js